import { createResource } from 'react-resource-router';

import { assert, AssertionError } from '@atlassian/eoc-common';

import { isTeamReportsUrl } from '../../common/utils';
import { getDashboards, getReportRights, getReportSettings } from '../endpoints';

export const opsReportsResource = createResource({
	type: 'opsReportsResource',
	getKey: () => 'opsReportsResource',
	getData: async () => {
		const settings = await getReportSettings();

		const api = getDashboards;

		return {
			settings,
			dashboards: settings.showReportingMaintenance ? null : await api(),
		};
	},
	maxAge: Infinity,
	isBrowserOnly: true,
});

export const opsReportsPermissionResource = createResource({
	type: 'opsReportsPermissionResource',
	getKey: ({ match }) => {
		return `opsReportsPermissionResource-${match.params?.teamId}`;
	},
	getData: async (routerContext) => {
		const isTeamDashboard = isTeamReportsUrl(routerContext.match.url);
		const teamId = routerContext.match.params?.teamId;

		assert(
			!isTeamDashboard || !!teamId,
			new AssertionError(
				'opsReportsPermissionResource',
				'teamId should be set to fetch reports permissions on TeamDashboard page',
			),
		);
		return getReportRights(teamId);
	},
	isBrowserOnly: true,
	maxAge: Infinity,
});

export const resources = () => [opsReportsResource, opsReportsPermissionResource];
